import EmlParser from '~/components/mail-viewer/eml-parser';

export default encodedString => EmlParser.unquoteString(encodedString || '');
